// extracted by mini-css-extract-plugin
export default {"container":"FBgP8q","containerUx4":"lvdtAU"};